import { NgModule } from '@angular/core';
import { MaterialModule } from 'carehub-shared/material.module';
import { SharedModule } from 'carehub-shared/shared.module';
import { PartnerInfoComponent } from './components/controls/panels/partner-info/partner-info.component';
import { MobileMemberIconComponent } from './components/member/member-banner/mobile-member-icon/mobile-member-icon.component';
import { ProblematicMemberIconComponent } from './components/member/member-banner/problematic-member-icon/problematic-member-icon.component';
import { WebMemberIconComponent } from './components/member/member-banner/web-member-icon/web-member-icon.component';
import { AddMedicalPlanCoverageDialogComponent } from './components/controls/panels/add-medical-plan-coverage-dialog/add-medical-plan-coverage-dialog.component';
@NgModule({
  imports: [SharedModule, MaterialModule],
  exports: [
    ProblematicMemberIconComponent,
    MobileMemberIconComponent,
    WebMemberIconComponent,
    PartnerInfoComponent,
    AddMedicalPlanCoverageDialogComponent,
  ],
  entryComponents: [],
  declarations: [
    ProblematicMemberIconComponent,
    MobileMemberIconComponent,
    WebMemberIconComponent,
    PartnerInfoComponent,
    AddMedicalPlanCoverageDialogComponent,
  ],
})
export class MembersSubWithoutRoutingModule {}
